var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-30.72 -30.72 573.44 573.44",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#ffffff;} "), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.256,
    y: 222.607,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.863,
    y: 222.607,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.662,
    y: 222.607,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.256,
    y: 302.11,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.662,
    y: 302.11,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.46,
    y: 302.11,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.863,
    y: 381.612,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.662,
    y: 381.612,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.46,
    y: 381.612,
    className: "st0",
    width: 50.881,
    height: 50.885
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M439.277,55.046h-41.376v39.67c0,14.802-12.195,26.84-27.183,26.84h-54.025 c-14.988,0-27.182-12.038-27.182-26.84v-39.67h-67.094v39.297c0,15.008-12.329,27.213-27.484,27.213h-53.424 c-15.155,0-27.484-12.205-27.484-27.213V55.046H72.649c-26.906,0-48.796,21.692-48.796,48.354v360.246 c0,26.661,21.89,48.354,48.796,48.354h366.628c26.947,0,48.87-21.692,48.87-48.354V103.4 C488.147,76.739,466.224,55.046,439.277,55.046z M453.167,462.707c0,8.56-5.751,14.309-14.311,14.309H73.144 c-8.56,0-14.311-5.749-14.311-14.309V178.089h394.334V462.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M141.525,102.507h53.392c4.521,0,8.199-3.653,8.199-8.144v-73.87c0-11.3-9.27-20.493-20.666-20.493h-28.459 c-11.395,0-20.668,9.192-20.668,20.493v73.87C133.324,98.854,137.002,102.507,141.525,102.507z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M316.693,102.507h54.025c4.348,0,7.884-3.513,7.884-7.826V20.178C378.602,9.053,369.474,0,358.251,0H329.16 c-11.221,0-20.349,9.053-20.349,20.178v74.503C308.81,98.994,312.347,102.507,316.693,102.507z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem4);
export default __webpack_public_path__ + "static/media/item4.0e865c1ff28cf19e6e981a3b477fe897.svg";
export { ForwardRef as ReactComponent };